import React from 'react';
import { useFieldBulletinBoardRegister } from '../../services/fieldBulletinBoard/FieldBulletinBoardRegisterContext';
import { FieldBulletinBoardHeader } from './FieldBulletinBoardHeader';

import { messageUtility } from '../../utilities/messageUtility';

/**
 * 現場掲示板新規作成 ヘッダー
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardHeaderRegister() {
  const {
    handleBack,
    closeConfirmDialog,
    getModalDisplayInfo,
    executeBack,
  } = useFieldBulletinBoardRegister();

  return (
    <FieldBulletinBoardHeader
      handleBack={handleBack}
      masterHeadertitle={messageUtility.getMessage('I-000-165-36')}
      breadcrumbsName={messageUtility.getMessage('I-000-165-35')}
      closeConfirmDialog={closeConfirmDialog}
      getModalDisplayInfo={getModalDisplayInfo}
      executeBack={executeBack}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardHeaderRegister.jsx